// import moment from 'moment';

import * as lib from '../../lib/format';
export const slugify = lib.slugify;
export const baseify = lib.baseify;

//export * from '../../lib/format';

const LOCALE = 'da-DK';

const formats = new Map();

function getFormat(mapKey, format, formatType) {
  mapKey = mapKey || JSON.stringify(format);

  let fmt = formats.get(mapKey);
  if (!fmt) {
    fmt = new Intl[formatType](format.locale, format.options).format;
    formats.set(mapKey, fmt);
  }

  return fmt;
}

export function getDateTimeFormat(format, mapKey) {
  return getFormat(mapKey || JSON.stringify(format), format, 'DateTimeFormat');
}

export function getNumberFormat(format, mapKey) {
  return getFormat(mapKey || JSON.stringify(format), format, 'NumberFormat');
}

// export const momentDateFormat = 'D. MMMM YYYY';
// export const momentDateTimeFormat = `${momentDateFormat}, HH:mm:ss`;
//
// export function formatMomentDate (date) {
//   return moment(date).format(momentDateFormat);
// }
// export function formatMomentDateTime (date) {
//   return moment(date).format(momentDateTimeFormat);
// }

function formatLocaleDateTime(date, opts, onlyFuture) {
  let timeZoneOffset = -60;
  if (Array.isArray(date)) {
    timeZoneOffset = date[1];
    date = date[0];
  }
  if (typeof date === 'string') {
    date = new Date(date);
  }

  const ts = date.getTime();
  if (isNaN(ts) || (onlyFuture && ts < Date.now())) {
    return '';
  }

  const fmtKey = (typeof opts === 'string' && opts) || JSON.stringify(opts);

  if (opts === 'long') {
    opts = { year: 'numeric', month: 'long', day: 'numeric' };
  } else if (opts === 'short') {
    opts = { year: 'numeric', month: 'short', day: 'numeric' };
  }

  if (__CLIENT__) {
    opts.timeZone = 'UTC';
    // const timeZoneOffset = -120; //new Date().getTimezoneOffset();
    date.setMinutes(date.getMinutes() - timeZoneOffset);
    // opts.timeZone = 'Europe/Copenhagen';
  }

  return getDateTimeFormat({ locale: LOCALE, options: opts }, fmtKey)(date);
}

export function formatDate(date, onlyFuture = false) {
  return formatLocaleDateTime(
    date,
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    onlyFuture
  );
}
export function formatDateTime(date, onlyFuture = false) {
  return formatLocaleDateTime(
    date,
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    },
    onlyFuture
  ).replace(/ ([0-9]{2})\.([0-9]{2})\.([0-9]{2})$/, ', $1:$2:$3');
}

export function numberWithCurrency(number, factor = 100) {
  const str = (number / factor).toFixed(2).replace('.', ',');
  return `${str} kr.`;
}
